<template>
  <div class="ps-wrap">

    <!-- Segurança Tips -->
    <div class="ps-tips">
      <div class="ps-tip">
        <div class="ps-tip-icon ps-tip-ok">
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>
        </div>
        <span>Mínimo 8 caracteres</span>
      </div>
      <div class="ps-tip">
        <div class="ps-tip-icon ps-tip-ok">
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>
        </div>
        <span>Ao menos uma letra maiúscula e um número</span>
      </div>
      <div class="ps-tip">
        <div class="ps-tip-icon ps-tip-ok">
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>
        </div>
        <span>Não reutilize senhas antigas</span>
      </div>
    </div>

    <div class="ps-divider-label">Alterar senha</div>

    <!-- Senha Antiga -->
    <div class="ps-section">
      <div class="ps-form-grid">

        <div class="ps-field">
          <label class="ps-label">Senha atual</label>
          <div class="ps-input-wrap">
            <input
              ref="SenhaAntiga"
              v-model="oldPassword"
              :type="passwordFieldTypeOld"
              class="ps-input"
              placeholder="Digite sua senha atual"
              autocomplete="current-password"
            >
            <button class="ps-eye" type="button" @click="togglePasswordOld">
              <svg v-if="passwordFieldTypeOld === 'password'" width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/></svg>
              <svg v-else width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            </button>
          </div>
        </div>

        <div class="ps-field">
          <label class="ps-label">Nova senha</label>
          <div class="ps-input-wrap">
            <input
              ref="NovaSenha"
              v-model="password"
              :type="password1FieldType"
              class="ps-input"
              placeholder="Digite sua nova senha"
              autocomplete="new-password"
            >
            <button class="ps-eye" type="button" @click="togglePassword1Visibility">
              <svg v-if="password1FieldType === 'password'" width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/></svg>
              <svg v-else width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            </button>
          </div>

          <!-- Strength bar -->
          <div class="ps-strength" v-if="password">
            <div class="ps-strength-track">
              <div class="ps-strength-fill" :style="{ width: strengthPct + '%', background: strengthColor }"></div>
            </div>
            <span class="ps-strength-label" :style="{ color: strengthColor }">{{ strengthLabel }}</span>
          </div>
        </div>

        <div class="ps-field">
          <label class="ps-label">Confirmar nova senha</label>
          <div class="ps-input-wrap" :class="{ 'ps-input-wrap-err': cPassword && password !== cPassword }">
            <input
              ref="NovaSenha2"
              v-model="cPassword"
              :type="password2FieldType"
              class="ps-input"
              placeholder="Confirme sua nova senha"
              autocomplete="new-password"
            >
            <button class="ps-eye" type="button" @click="togglePassword2Visibility">
              <svg v-if="password2FieldType === 'password'" width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/></svg>
              <svg v-else width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            </button>
          </div>
          <span v-if="cPassword && password !== cPassword" class="ps-error-msg">As senhas não coincidem</span>
        </div>

      </div>

      <!-- Error message -->
      <div v-if="Error" class="ps-error-banner">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        {{ Error }}
      </div>
    </div>

    <!-- Footer -->
    <div class="ps-footer">
      <button class="ps-btn ps-btn-ghost" type="button" @click="clearInput">Limpar campos</button>
      <button
        class="ps-btn ps-btn-primary"
        type="button"
        :disabled="!canSubmit"
        @click="validationForm"
      >
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        Definir nova senha
      </button>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      oldPassword: '',
      password: '',
      cPassword: '',
      user_primeiro_acesso: 0,
      Error: '',
      passwordFieldTypeOld: 'password',
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },

  computed: {
    canSubmit() {
      return this.oldPassword && this.password && this.cPassword && this.password === this.cPassword
    },
    strengthScore() {
      const p = this.password
      if (!p) return 0
      let s = 0
      if (p.length >= 8) s++
      if (/[A-Z]/.test(p)) s++
      if (/[0-9]/.test(p)) s++
      if (/[^A-Za-z0-9]/.test(p)) s++
      return s
    },
    strengthPct() {
      return (this.strengthScore / 4) * 100
    },
    strengthColor() {
      const c = ['#C12B2B', '#E86A10', '#F5B935', '#28c76f']
      return c[this.strengthScore - 1] || '#e5e8ef'
    },
    strengthLabel() {
      const l = ['Fraca', 'Regular', 'Boa', 'Forte']
      return l[this.strengthScore - 1] || ''
    },
  },

  methods: {
    togglePasswordOld() { this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password' },
    togglePassword1Visibility() { this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password' },
    togglePassword2Visibility() { this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password' },

    validationForm() {
      this.Error = ''
      // eslint-disable-next-line
      const md5 = require('md5')
      const senhaAntigaHash = md5(this.oldPassword)
      if (senhaAntigaHash !== this.userData.user_password) {
        this.Error = 'Senha atual está incorreta. Verifique e tente novamente.'
        return
      }
      if (this.password !== this.cPassword) {
        this.Error = 'Nova senha e confirmação precisam ser iguais.'
        return
      }
      this.open()
    },

    redefinirSenha() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/password/${this.userData.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ user_password: this.password, user_primeiro_acesso: this.user_primeiro_acesso }),
      })
        .then(response => {
          if (response) {
            this.clearInput()
            this.$notify({ title: 'Senha alterada!', message: 'Sua senha foi atualizada com sucesso. Mantenha-a em segurança.', type: 'success' })
          }
        })
        .catch(err => console.error(err))
    },

    clearInput() {
      this.oldPassword = ''
      this.password = ''
      this.cPassword = ''
      this.Error = ''
    },

    open() {
      this.$msgbox({
        title: 'Confirmar alteração de senha',
        message: this.$createElement('p', null, [
          this.$createElement('span', null, `Olá ${this.userData.user_name}, você está prestes a alterar sua senha. Confirma a operação?`),
        ]),
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.redefinirSenha()
            instance.confirmButtonLoading = true
            instance.confirmButtonText = 'Aguarde…'
            setTimeout(() => {
              done()
              setTimeout(() => { instance.confirmButtonLoading = false }, 300)
            }, 2000)
          } else {
            done()
            this.clearInput()
          }
        },
      })
    },
  },
}
</script>

<style scoped>
/* ─── Wrap ─── */
.ps-wrap { background: var(--dk-bg-card, #fff); }

/* ─── Tips ─── */
.ps-tips { display: flex; flex-wrap: wrap; gap: 12px; padding: 20px 24px 0; }
.ps-tip { display: flex; align-items: center; gap: 7px; font-size: 12.5px; color: var(--dk-text-muted, #8a94a6); }
.ps-tip-icon {
  width: 20px; height: 20px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ps-tip-ok { background: rgba(40,199,111,0.12); color: #1e9957; }

/* ─── Divider ─── */
.ps-divider-label {
  padding: 10px 24px;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--dk-text-faint, #aab0bc);
  background: var(--dk-bg-card-hover, #fafbfc);
  border-top: 1px solid var(--dk-border-light, #f5f6fa);
  border-bottom: 1px solid var(--dk-border-light, #f5f6fa);
  margin-top: 16px;
}

/* ─── Section ─── */
.ps-section { padding: 20px 24px; }
.ps-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }

/* ─── Fields ─── */
.ps-field { display: flex; flex-direction: column; gap: 6px; }
.ps-label { font-size: 12.5px; font-weight: 600; color: var(--dk-text-primary, #344563); }

.ps-input-wrap {
  display: flex; align-items: center;
  border: 1.5px solid var(--dk-border-input, #e5e8ef); border-radius: 9px;
  background: var(--dk-bg-card, #fff); overflow: hidden; transition: border-color 0.15s;
}
.ps-input-wrap:focus-within { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.1); }
.ps-input-wrap-err { border-color: #C12B2B !important; }
.ps-input-wrap-err:focus-within { box-shadow: 0 0 0 3px rgba(193,43,43,0.1); }

.ps-input {
  flex: 1; padding: 10px 13px; border: none; outline: none;
  font-size: 14px; color: var(--dk-text-primary, #1a2d42); background: transparent;
}
.ps-eye {
  width: 40px; height: 100%; background: none; border: none; cursor: pointer;
  color: var(--dk-text-faint, #aab0bc); display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; transition: color 0.15s;
}
.ps-eye:hover { color: #E86A10; }

/* ─── Strength ─── */
.ps-strength { display: flex; align-items: center; gap: 10px; }
.ps-strength-track { flex: 1; height: 4px; background: var(--dk-border-light, #f0f2f5); border-radius: 4px; overflow: hidden; }
.ps-strength-fill { height: 100%; border-radius: 4px; transition: width 0.3s, background 0.3s; }
.ps-strength-label { font-size: 11.5px; font-weight: 600; min-width: 50px; }

/* ─── Error ─── */
.ps-error-msg { font-size: 12px; color: #C12B2B; }
.ps-error-banner {
  display: flex; align-items: center; gap: 8px;
  padding: 11px 14px; border-radius: 9px; margin-top: 16px;
  background: rgba(193,43,43,0.07); color: #C12B2B;
  font-size: 13px; font-weight: 500;
}

/* ─── Footer ─── */
.ps-footer {
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 16px 24px;
  border-top: 1.5px solid var(--dk-border-light, #f5f6fa);
}
.ps-btn {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 9px 18px; border-radius: 9px;
  font-size: 13.5px; font-weight: 600; cursor: pointer; border: none; transition: all 0.15s;
}
.ps-btn-primary {
  background: linear-gradient(135deg, #E86A10, #f08535); color: #fff;
  box-shadow: 0 4px 12px rgba(232,106,16,0.25);
}
.ps-btn-primary:hover:not(:disabled) { background: linear-gradient(135deg, #cf5e0d, #E86A10); }
.ps-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
.ps-btn-ghost { background: var(--dk-bg-inset, #f5f6fa); color: var(--dk-text-secondary, #6b7280); }
.ps-btn-ghost:hover { background: var(--dk-bg-card-hover, #edf0f3); }

@media (max-width: 600px) {
  .ps-form-grid { grid-template-columns: 1fr; }
  .ps-tips { flex-direction: column; }
}
</style>
